import React, { useEffect, useState } from 'react'
import { theme } from '../../utils/constant'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button } from '@mui/material'

type PinKeyBoardProps = {
  onTap: (number: number) => void
  reload?: any
}

export function PinKeyboard({ onTap, reload }: PinKeyBoardProps) {
  const [arrayNumbers, setArrayNumbers] = useState<number[]>()

  const shuffleArray = (array: number[]): number[] => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[array[i], array[j]] = [array[j], array[i]]
    }
    return array
  }

  useEffect(() => {
    const numbers: number[] = [...Array(10).keys()]
    setArrayNumbers(shuffleArray(numbers))
  }, [])

  return arrayNumbers ? (
    <div className="h-full w-full">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="my-2 flex items-center justify-center gap-[3vmax]">
          {[0, 1, 2].map((ii) => (
            <div
              key={i * 3 + ii + 1}
              className="flex h-full w-full items-center justify-center">
              <Button
                variant="contained"
                style={{
                  backgroundColor: theme.colors.grey,
                  width: '5rem',
                  height: '2.8rem',
                  fontSize: 18,
                  color: 'black',
                  margin: '0.5vmax 0',
                  borderRadius: '1rem',
                }}
                onClick={() => onTap(arrayNumbers[i * 3 + ii + 1])}>
                {arrayNumbers[i * 3 + ii + 1]}
              </Button>
            </div>
          ))}
        </div>
      ))}
      <div className="my-2 flex items-center justify-center gap-[3vmax]">
        <div className="flex items-center justify-center">
          <div className="my-[0.5vmax] h-[2.8rem] w-[5rem]"></div>
        </div>
        <div className="flex items-center justify-center">
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.grey,
              width: '5rem',
              height: '2.8rem',
              fontSize: 18,
              color: 'black',
              margin: '0.5vmax 0',
              borderRadius: '1rem',
            }}
            onClick={() => onTap(arrayNumbers[0])}>
            {arrayNumbers[0]}
          </Button>
        </div>
        <div className="flex items-center justify-center">
          <Button
            style={{
              backgroundColor: theme.colors.grey,
              width: '5rem',
              height: '2.8rem',
              fontSize: 18,
              color: 'black',
              margin: '0.5vmax 0',
              borderRadius: '1rem',
            }}
            aria-label="backspace"
            onClick={() => onTap(-1)}>
            <ArrowBackIcon />
          </Button>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}
